export const MODULE_LIST_SUCCESS = "MODULE_LIST_SUCCESS";
export const LOADING_MODULE_LIST = "LOADING_MODULE_LIST";
